<div id="main-content" class="page-wrapper" [class]="'layout-with-margin-' + (layoutSystemObservable$ | async)">
    <router-outlet></router-outlet>
</div>
